/**
 * Vue Router navigation guard.
 * Checks auth state and redirects as needed.
 */
import { authState } from './authState'
import { hasPermission } from './permissions'

export function createAuthGuard(router) {
  router.beforeEach(async (to, from, next) => {
    // Public routes (login, auth callback) bypass checks
    if (to.meta.public) {
      return next()
    }

    // Wait for initial auth check to complete
    if (authState.isLoading) {
      await waitForAuthReady()
    }

    // Auth required but not authenticated
    if (to.matched.some(r => r.meta.requiresAuth) && !authState.isAuthenticated) {
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }

    // Tenant required but none selected
    if (authState.isAuthenticated && authState.requiresTenantSelection && to.name !== 'SelectTenant') {
      return next({ name: 'SelectTenant' })
    }

    // Permission-gated route
    const requiredPermission = to.matched.slice().reverse().find(r => r.meta.requiresPermission)?.meta.requiresPermission
    if (requiredPermission && !hasPermission(requiredPermission)) {
      return next({ path: '/' })
    }

    next()
  })
}

function waitForAuthReady() {
  return new Promise(resolve => {
    const check = () => {
      if (!authState.isLoading) {
        resolve()
      } else {
        setTimeout(check, 50)
      }
    }
    check()
  })
}
